import { rem } from 'polished';
import { breakpoints, css } from '../../../styles/theme';

export const StylesOVGB = css`
  background-color: ${({ theme }) => theme.colors.white};

  .my-account-page {
    background: ${p => p.theme.colors.white};

    .my-account-content {
      display: flex;
      justify-content: center;

      &-title {
        display: none;
        margin-left: ${rem('12px')};
        font-weight: normal;
        @media (min-width: ${breakpoints.xs}px) {
          display: initial;
          text-transform: uppercase;
          line-height: ${rem('36px')};
          margin-bottom: ${rem('30px')};
          font-size: ${rem('24px')};
        }

      }

      .my-account-controller {
        display: flex;
      }

      .my-account-home .imgbtn {
        height: ${rem(220)};
        width: ${rem('328px')};
        margin: ${rem('16px')};
        @media (min-width: ${breakpoints.xs}px) {
          width: ${rem('328px')};
          margin: 0 ${rem('16px')};
        }
      }

    }
`;
